'use strict';

const React = require('react');
const uuid = require('uuid');

const Strings =              require('../../../../../app/shared/Strings');

import VoiceStore from '../../../stores/VoiceStore';
import VoiceActions from '../../../actions/VoiceActions';
import AccessibleIcon from '../../common/AccessibleIcon';

// volume and play/pause
class VoiceControls extends React.Component {
    constructor(props) {
        super(props);
        let storeState = VoiceStore.getState();
        let { options, voiceElement } = storeState;
        let playing = !voiceElement.paused
        let { volume, disabled } = options;
        this.state = {
            volume,disabled,
            playing,
            expanded: false,
        };
        this.unsubscribes = [VoiceStore.listen(this.onVoiceStoreChange)];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    onVoiceStoreChange=(storeState)=>{
        const { options, voiceElement } = storeState;
        let { volume, disabled }  = options;
        let playing = !voiceElement.paused;
//        if (storeState.action.id === 'start_or_stop') {
//            playing = !!voiceElement.start;
//        }
        this.setState({volume, disabled, playing});
    }

    setVolume=(e)=>{
        let volume = Number(e.target.value);
        let opt = VoiceStore.getState().options;
        let options = {...opt, volume };
        VoiceActions.setVoiceOptions(uuid.v4(),options); 
    }

//    setEnabled=(e)=>{
//        let disabled = !e.target.checked;
//        let options = {...this.state.options, disabled };
//        VoiceActions.setVoiceOptions(uuid.v4(),options); 
//    }

    togglePlayPause=()=>{
        let playing = this.state.playing ? false : true; // toggle
        this.setState({playing},()=>{
            VoiceActions.setVoiceElementPlay(uuid.v4(),playing);
        });
    }

    toggleExpanded=()=>{
        this.setState({expanded: !this.state.expanded});
    }

    render() {
        let iconClass;
        let title;
        if (this.state.playing) {
            iconClass ="fa fa-pause";
            title = "pause";
        }
        else {
            iconClass = "fa fa-play";
            title = "play";
        }

        return ( 
            <div className="voice-controls">
                <div className="top-buttons">
                    <button className="play-pause-icon" title={title} onClick={this.togglePlayPause}>
                        <span className={iconClass}/>
                    </button>
                    <button className="expand-button" onClick={this.toggleExpanded} title="Voice Controls">
                        <AccessibleIcon label="Voice Controls">
                            <span className="fa fa-cog" aria-hidden={true}/>
                        </AccessibleIcon>
                    </button>
                </div>
                {this.state.expanded ? 
                <div className="voice-controls-expanded-section">
                    <div className="volume-control">
                        <div className="voice-slider">
                            <i className="fas fa-volume-down" aria-hidden="true" />
                            <input type="range" id="voice-volume-slider"
                                min="0" max="100" 
                                value={this.state.volume} 
                                step="10" 
                                className="slider-input" 
                                aria-label="Voice Volume"
                                aria-valuetext={this.state.volume + "%"}
                                onChange={this.setVolume}
                            />
                            <i className="fas fa-volume-up" aria-hidden="true" />
                            <label htmlFor="voice-volume-slider">Volume</label>
                        </div>
                        {/* disabled in favor of setting volume (volume 0=disabled)
                        <div className="checkbox-row">
                            <div className="centered-h">
                                <input id="voice-enable-disable" type="checkbox" checked={!this.state.disabled} onChange={this.setEnabled}/>
                                <label htmlFor="voice-enable-disable">{Strings["en"].voice_options.VOICE_ENABLED}</label>
                            </div>
                        </div>
                        */}
                    </div>
                </div>
                : null }
            </div>
        );
    }
};

module.exports = VoiceControls;

